var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor logos / Klarna"
  }, /*#__PURE__*/React.createElement("g", {
    id: "klarna"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: 4,
    width: 56.6667,
    height: 31.4815,
    rx: 4.321,
    fill: "#FFB3C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4245 20.495C12.9777 18.9344 13.8493 16.8348 13.8493 14.5778L13.8493 14.5778H11.5296C11.5296 16.4963 10.6555 18.2572 9.13139 19.4092L8.21237 20.1037L11.7733 25.0035H14.7011L11.4245 20.495ZM5.55835 25.0031H7.92878V14.5778H5.55835V25.0031ZM17.6306 25.0003H15.392V14.5798H17.6306V25.0003ZM46.9604 17.792H49.0991V25.0002H46.9604V24.5395C46.3562 24.9553 45.6268 25.1998 44.8402 25.1998C42.7585 25.1998 41.0708 23.4969 41.0708 21.3962C41.0708 19.2955 42.7585 17.5927 44.8402 17.5927C45.6268 17.5927 46.3562 17.8371 46.9604 18.2531V17.792ZM45.0153 19.5418C46.0856 19.5418 46.9532 20.372 46.9532 21.3962C46.9532 22.4205 46.0857 23.2509 45.0153 23.2509C43.9449 23.2509 43.0773 22.4205 43.0773 21.3962C43.0773 20.372 43.945 19.5418 45.0153 19.5418ZM50.0274 23.7981C50.0274 23.0499 50.6284 22.4435 51.3698 22.4435C52.1112 22.4435 52.7123 23.0499 52.7123 23.7981C52.7123 24.5461 52.1112 25.1527 51.3698 25.1527C50.6284 25.1527 50.0274 24.5461 50.0274 23.7981ZM29.8445 17.7921V18.7309L29.8445 18.731C30.2733 18.1679 31.0721 17.7926 31.9407 17.7926V19.8901C31.9366 19.89 31.9327 19.8898 31.9288 19.8896L31.9217 19.8892L31.9153 19.8891C31.069 19.8891 29.8494 20.4994 29.8494 21.6348V25.0002H27.6548V17.7921H29.8445ZM24.3899 21.3962C24.3899 20.372 23.5222 19.5419 22.4519 19.5419C21.3817 19.5419 20.5139 20.372 20.5139 21.3962C20.5139 22.4205 21.3816 23.2509 22.4519 23.2509C23.5223 23.2509 24.3899 22.4205 24.3899 21.3962ZM26.5358 17.792H24.397V18.2531C23.7928 17.8372 23.0635 17.5927 22.2769 17.5927C20.1951 17.5927 18.5074 19.2955 18.5074 21.3962C18.5074 23.4969 20.1951 25.1998 22.2769 25.1998C23.0634 25.1998 23.7928 24.9554 24.397 24.5395V25.0002H26.5358V17.792ZM37.2704 17.5981C36.416 17.5981 35.6074 17.8658 35.0668 18.6042V17.7924H32.9373V25.0003H35.093V21.2123C35.093 20.1162 35.8215 19.5794 36.6986 19.5794C37.6386 19.5794 38.179 20.146 38.179 21.1975V25.0003H40.3152V20.4165C40.3152 18.739 38.9934 17.5982 37.2704 17.5982V17.5981Z",
    fill: "#0A0B09"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/Klarna.fc904d37d54eee39abd019278df8718e.svg";
export { ForwardRef as ReactComponent };